import React from 'react';
import ReactDOM from 'react-dom';
import plans from "../../data/plans";
import { TwoLabelSwitch } from '../TwoLabelSwitch';
import { CloseIcon } from '../../icons/Close';
import pcLogo from '../../images/pc-logo.png';
import pcpLogo from '../../images/pcp-logo.png';
import { usePopup } from '../../hooks/usePopup';
import Plan from '../Plan';
import { getMediaUrl } from '../../utils/utils';
import './PopupMembership.scss';
import BrowserLink from '../BrowserLink';

export function PopupMembership({
  plan,
  isYearlyActive = false,
  closeModal
}) {
  usePopup(closeModal);

  return ReactDOM.createPortal(
    <div className="PopupMembership">
      <button className="PopupMembership__close" onClick={closeModal}>
        <CloseIcon />
      </button>
      <h2 className="PopupMembership__title">{`Your free trial to PokerCoaching ${plan} is active!`}</h2>
      <p className="PopupMembership__trial-info">You will automatically be billed after your trial period ends.</p>
      <p className="PopupMembership__plan-info">{`As a ${plan.toUpperCase()} member, you now have access to:`}.</p>

      {plan === 'Premium' ? (
        <img src={getMediaUrl(pcpLogo)} alt="pokercoaching premium" className="PopupMembership__logo" />
      ) : (
        <img src={getMediaUrl(pcLogo)} alt="pokercoaching be the shark" className="PopupMembership__logo" />
      )}

      <p className="PopupMembership__description">Save 20% with Annual Pricing - Cancel Anytime</p>

      {(plan === 'Standard' || plan === 'Premium') && (
        <TwoLabelSwitch
          disabled
          labelBefore="Monthly"
          labelAfter="Yearly"
          checked={isYearlyActive}
          onChange={() => {}}
        />
      )}

      {plan === 'Standard' && (
        <Plan wide ctaButtons={false} theme="secondary" isYearly={isYearlyActive} data={plans.standard} />
      )}

      {plan === 'Premium' && (
        <Plan wide ctaButtons={false} theme="primary" isYearly={isYearlyActive} data={plans.premium} />
      )}

      <p className="PopupMembership__cancel-info">{`To cancel your ${plan.toUpperCase()} membership,`} <BrowserLink href="/my-account/subscriptions/">click here</BrowserLink>.</p>
    </div>,
    document.getElementById('pc-popup-portal'));
}
